import { Grid, Paper } from "@mui/material";
import { Contact } from "../types/Contact";
import ContactCard from "./ContactCard";
import { grey, lightBlue } from "@mui/material/colors";
import { Actions } from "../types/Actions";
import { StrictModeDroppable } from "./overrides/StrictModeDroppable";
import { ContactUpdatePayload } from "../services/connector";

export default function CardZone({
    contacts,
    status,
    onCardAction,
    onContactUpdate
}: {
    contacts: Contact[];
    status: string;
    onCardAction: (contact: Contact, action: Actions) => void;
    onContactUpdate: (contact: Contact, payload: ContactUpdatePayload) => void;
}) {
    return (
        <StrictModeDroppable droppableId={status}>
            {(provided, snapshot) => {
                return (
                    <Paper
                        {...provided.droppableProps}
                        elevation={4}
                        ref={provided.innerRef}
                        sx={{
                            p: 2,
                            backgroundColor: snapshot.isDraggingOver
                                ? lightBlue[50]
                                : grey[50],
                            flex: 1,
                            overflow: "auto",
                        }}
                    >
                        {contacts.map((contact, index) => (
                            <Grid item xs={12} key={contact.id} sx={{ mb: 2 }}>
                                <ContactCard
                                    contact={contact}
                                    index={index}
                                    onCardAction={onCardAction}
                                    onContactUpdate={onContactUpdate}
                                />
                            </Grid>
                        ))}
                    </Paper>
                );
            }}
        </StrictModeDroppable>
    );
}
